<div *ngIf="isMobile; else webLogin" class="full-container">
  <app-auth-header></app-auth-header>
  <div class="pending-mobile-container">
    <div class="container-elements">
      <div class="top-content">
        <div class="top-title">
          Your registration <br> for the P2P platform is <br> almost complete
        </div>
        <div class="divider"></div> 
        <div class="middle-title">
          To ensure <br> only authorized users manage <br> their meters, we will send a <br> confirmation email to you. 
          <br /><br />
          Once confirmed, <br> you will be able to log in.
        </div>
      </div>
      <div class="bottom-content">
        <div class="login-button-mobile">
          <button  (click)="navigateTo('/login')">Login</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #webLogin>
  <div class="main">
    <div class="main-content">
      <div class="bid-type waitting"></div>
      <div class="main-content-row">
        <div class="main-content-value">
          Your registration for the P2P Platform is almost complete
        </div>
      </div>
      <div class="seperator"></div>
      <div class="footer">
          To ensure only authorized users manage their meters, we will send a confirmation email to your address.
        <br /><br />
        Once confirmed, you'll be able to log in.
      </div>
      <button class="login-button" (click)="navigateTo('/login')">Login</button>
    </div>
  </div>
</ng-template>

